import { User } from './user.entity';

export class CoronaOfficeAttendance {
  id?: number;
  creationDate?: Date;
  attendanceDate?: Date;
  startDate?: Date;
  endDate?: Date;
  comment?: string;
  signature?: string;
  user?: User;
}
